import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useAuth } from '../components/auth/AuthContext';
import {
  Container,
  Typography,
  TextField,
  Button,
  Box,
} from '@mui/material';
import axios from 'axios';

const PublishNews = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { schoolId: contextSchoolId } = useAuth();
  const schoolId = location.state?.schoolId || contextSchoolId;

  const [title, setTitle] = useState('');
  const [details, setDetails] = useState('');
  const [publisher, setPublisher] = useState('');

  const handlePublishNews = async () => {
    if (!schoolId) {
      alert('Error: School ID is missing. Please log in again.');
      return;
    }

    const newsData = {
      title,
      details,
      publisher,
      schoolId,
    };

    try {
      const response = await axios.post('https://kidsm.vercel.app/api/schools/publish-news', newsData);
      if (response.status === 201) {
        alert('Success: News published successfully!');
        navigate(-1);
      }
    } catch (error) {
      console.error('Error publishing news:', error.response?.data || error.message);
      alert('Error: ' + (error.response?.data?.message || 'Failed to publish news. Please try again.'));
    }
  };

  return (
    <Container maxWidth="md" sx={{ py: 4, bgcolor: '#f8f9fa', minHeight: '100vh' }}>
      <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5 }}>
        <Typography variant="h4" sx={{ fontWeight: 'bold', color: '#2c3e50', mb: 3 }}>
          Publish News
        </Typography>
        <Box component="form" sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <TextField
            label="Title"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            fullWidth
            variant="outlined"
            sx={{ bgcolor: '#fff' }}
          />
          <TextField
            label="Details"
            value={details}
            onChange={(e) => setDetails(e.target.value)}
            fullWidth
            variant="outlined"
            sx={{ bgcolor: '#fff' }}
            multiline
            rows={6}
          />
          <TextField
            label="Publisher"
            value={publisher}
            onChange={(e) => setPublisher(e.target.value)}
            fullWidth
            variant="outlined"
            sx={{ bgcolor: '#fff' }}
          />
          <Button
            variant="contained"
            sx={{ bgcolor: '#6200ee', mt: 2 }}
            onClick={handlePublishNews}
          >
            Publish News
          </Button>
        </Box>
      </motion.div>
    </Container>
  );
};

export default PublishNews;